import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-63a94a9e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  class: "image_boxs"
};
const _hoisted_3 = {
  key: 1,
  class: "boxs"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "dialog-footer"
};
import { reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Close } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import { setDictStatusApi, getDictapi } from "@/service/modules/role";
export default /*#__PURE__*/_defineComponent({
  __name: 'dicdialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    keys: {
      type: String,
      default: ""
    }
  },
  emits: ["closeDialog", "restData"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const emit = __emit;
    const props = __props;
    const loadings = ref(false);
    const formRef = ref();
    const rules = reactive({
      name: [{
        required: true,
        message: "请输入配置名称",
        trigger: "blur"
      }],
      wx: [{
        required: true,
        message: "请输入微信号",
        trigger: "blur"
      }],
      image: [{
        required: true,
        message: "请上传图片",
        trigger: "blur"
      }]
    });
    const closeDialog = () => {
      emit("closeDialog");
    };
    const subBtnLoading = ref(false);
    const form_data = reactive({
      name: "",
      key: "",
      value: [],
      wx: "",
      image: ""
    });
    async function init() {
      if (props.keys) {
        loadings.value = true;
        const res = await getDictapi(props.keys);
        if (res.data.key == "wx_num" || res.data.key == "note_share" || res.data.key == "home_share") {
          let new_value = JSON.parse(res.data.value);
          form_data.name = res.data.name;
          form_data.key = res.data.key;
          form_data.value = new_value;
          form_data.wx = new_value[0].value;
          form_data.image = new_value[1].value;
        }
        if (res.data.key == "home_swiper") {
          let new_value = JSON.parse(res.data.value);
          form_data.name = res.data.name;
          form_data.key = res.data.key;
          form_data.value = new_value;
          form_data.image = new_value[0].value;
        }
        loadings.value = false;
      }
    }
    init();
    function imgLoadSuccess(img) {
      form_data.image = img;
    }
    function del_img() {
      form_data.image = "";
    }
    function imgTypeError() {
      ElMessage.warning("仅支持jpg/jpeg/png格式图片");
    }
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    async function submit() {
      subBtnLoading.value = true;
      if (form_data.key == "wx_num" || form_data.key == "note_share" || form_data.key == "home_share") {
        let reqdata = {
          key: form_data.key,
          name: form_data.name,
          value: JSON.stringify([{
            label: "wx",
            value: form_data.wx
          }, {
            label: "image",
            value: form_data.image
          }])
        };
        const res = await setDictStatusApi(reqdata);
        emit("restData");
        subBtnLoading.value = false;
      }
      if (form_data.key == "home_swiper") {
        let reqdata = {
          key: form_data.key,
          name: form_data.name,
          value: JSON.stringify([{
            label: "image",
            value: form_data.image
          }])
        };
        const res = await setDictStatusApi(reqdata);
        emit("restData");
        subBtnLoading.value = false;
      }
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_separate_upload = _resolveComponent("separate-upload");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: "修改配置",
        width: "35%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[4] || (_cache[4] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
          model: form_data,
          "label-width": "auto",
          ref_key: "formRef",
          ref: formRef,
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "配置名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form_data.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form_data.name = $event),
              placeholder: "请输入配置名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), form_data.key == 'wx_num' || form_data.key == 'note_share' || form_data.key == 'home_share' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "微信号/文案",
            prop: form_data.key == 'wx_num' || form_data.key == 'note_share' || form_data.key == 'home_share' ? 'wx' : ''
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form_data.wx,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form_data.wx = $event),
              placeholder: "请输入"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["prop"])) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "微信图/图片",
            prop: "image"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [!form_data.image ? (_openBlock(), _createBlock(_component_separate_upload, {
              key: 0,
              maxSize: 1,
              accept: ".jpg, .png, .jpeg",
              "file-types": ['image/png', 'image/jpeg'],
              onTypeError: imgTypeError,
              onUploadSuccess: _cache[2] || (_cache[2] = $event => imgLoadSuccess($event))
            })) : _createCommentVNode("", true), form_data.image ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
              class: "images_x",
              src: form_data.image,
              alt: ""
            }, null, 8, _hoisted_4), _createVNode(_component_el_icon, {
              size: "20",
              onClick: del_img,
              color: "#fff",
              class: "icons"
            }, {
              default: _withCtx(() => [_createVNode(_unref(Close))]),
              _: 1
            })])) : _createCommentVNode("", true)])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])), [[_directive_loading, loadings.value]])]),
        _: 1
      }, 8, ["model-value"])]);
    };
  }
});